import { atom } from "recoil";

// The current journey's lender, as learned by whichever journey screen read it first, so the
// next screen starts with it instead of waiting on its own fetch. `owner` is the session it was
// learned in; any other session ignores it (see pickJourneyLenderKey).
export const journeyLenderAtom = atom({
  key: "journeyLenderAtom",
  default: { owner: null, key: null },
});
